/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlDto } from './ControlDto';
import {
    ControlDtoFromJSON,
    ControlDtoFromJSONTyped,
    ControlDtoToJSON,
    ControlDtoToJSONTyped,
} from './ControlDto';

/**
 * 
 * @export
 * @interface ControlListResponse
 */
export interface ControlListResponse {
    /**
     * 
     * @type {Array<ControlDto>}
     * @memberof ControlListResponse
     */
    data?: Array<ControlDto>;
    /**
     * 
     * @type {number}
     * @memberof ControlListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the ControlListResponse interface.
 */
export function instanceOfControlListResponse(value: object): value is ControlListResponse {
    return true;
}

export function ControlListResponseFromJSON(json: any): ControlListResponse {
    return ControlListResponseFromJSONTyped(json, false);
}

export function ControlListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ControlDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function ControlListResponseToJSON(json: any): ControlListResponse {
    return ControlListResponseToJSONTyped(json, false);
}

export function ControlListResponseToJSONTyped(value?: ControlListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ControlDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

